export { default as Img200 } from './processed/200/santaanalane.jpg';
export { default as Img400 } from './processed/400/santaanalane.jpg';
export { default as Img600 } from './processed/600/santaanalane.jpg';
export { default as Imgthumb } from './processed/thumb/santaanalane.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/santaanalane.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/santaanalane.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      215,
      148,
      81
    ],
    "_population": 278,
    "_hsl": [
      0.08333333333333336,
      0.6261682242990655,
      0.580392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      234,
      155,
      168
    ],
    "_population": 355,
    "_hsl": [
      0.9725738396624473,
      0.6528925619834708,
      0.7627450980392156
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      106,
      45,
      20
    ],
    "_population": 77,
    "_hsl": [
      0.04844961240310078,
      0.6825396825396826,
      0.24705882352941178
    ]
  },
  "Muted": {
    "_rgb": [
      169,
      113,
      98
    ],
    "_population": 457,
    "_hsl": [
      0.035211267605633784,
      0.29218106995884763,
      0.5235294117647059
    ]
  },
  "LightMuted": {
    "_rgb": [
      157,
      205,
      195
    ],
    "_population": 2081,
    "_hsl": [
      0.4652777777777777,
      0.32432432432432434,
      0.7098039215686275
    ]
  },
  "DarkMuted": {
    "_rgb": [
      83,
      47,
      36
    ],
    "_population": 1722,
    "_hsl": [
      0.03900709219858157,
      0.39495798319327735,
      0.23333333333333334
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/santaanalane.js